<template>
  <FormCard :title="mode === 'edit' ? 'Данные прицепа' : 'Прицеп'" source="carrier">
    <FormGrid :cols="singleColumn ? 1 : 2">
      <FormField
        label="Номер прицепа"
        :invalid="(!form.number.valid && form.number.tochted) || !!errors.number"
        :error="errors.number || fieldError(form.number)"
      >
        <input
          id="trailer-number"
          v-model="form.number.value"
          type="text"
          :class="{ invalid: (!form.number.valid && form.number.tochted) || errors.number }"
          @blur="form.number.blur"
        />
      </FormField>
      <FormField
        label="Тип собственности"
          :invalid="ownershipTouched && !ownershipCode"
          :error="ownershipTouched && !ownershipCode ? 'Укажите тип собственности прицепа' : ''"
      >
        <select id="trailer-ownership" v-model="ownershipCode">
          <option value="">Не указан</option>
          <option v-for="opt in ownershipOptions" :key="opt.value" :value="opt.code">
            {{ opt.name }}
          </option>
        </select>
      </FormField>
      <FormField
        label="VIN прицепа"
        :invalid="(!form.vin.valid && form.vin.tochted) || !!errors.vin"
        :error="errors.vin || fieldError(form.vin)"
      >
        <input
          id="trailer-vin"
          v-model="form.vin.value"
          type="text"
          :class="{ invalid: (!form.vin.valid && form.vin.tochted) || errors.vin }"
          @blur="form.vin.blur"
        />
      </FormField>
    </FormGrid>

    <div v-if="!noButton" class="form-actions">
      <my-shrunk-button
        @click="sendForm"
        :btnSettings="{shrunk:true,name:''}"
      >{{ mode === 'edit' ? 'Сохранить' : 'Создать' }}</my-shrunk-button>
      <my-shrunk-button
        class="cancel-btn bg-denied"
        @click="closeForm"
        :btnSettings="{shrunk:true,name:''}"
      >Отменить</my-shrunk-button>
    </div>
  </FormCard>
</template>


<script>
import { computed, ref, watch } from 'vue'
import { useForm, useFormat, touchForm } from '@/hooks/form'
import {
  TRAILER_OWNERSHIP_OPTIONS,
  buildCarCreatePayload,
  findOwnershipOptionIn,
  validateTrailerCreateForm,
} from '@/constants/carOwnership'


export default {
  name: 'TrailerForm',
  props: {
    noButton: { type: Boolean, default: false },
    mode: { type: String, default: 'create' },
    initialData: { type: Object, default: () => ({}) },
    errors: { type: Object, default: () => ({}) },
    singleColumn: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const isEdit = computed(() => props.mode === 'edit')

    const form = useForm({
      number: {
        value: '',
        validators: ['required'],
      },
      vin: {
        value: '',
        validators: ['required', 'vin'],
      },
      is_trailer: {
        value: true,
        validators: [],
      },
    })

    const fillInitialData = (source = {}) => {
      if (!isEdit.value) return
      form.number.value = source.number || ''
      form.vin.value = source.vin || ''
    }
    watch(() => props.initialData, fillInitialData, { immediate: true })

    const ownershipOptions = TRAILER_OWNERSHIP_OPTIONS
    const initialOwnershipCode = computed(() => {
      const source = props.initialData || {}
      return findOwnershipOptionIn(
        ownershipOptions,
        source.ownership_type_id || source.ownership_type_name || source.ownership_type?.value,
      )?.code || ''
    })
    const selectedOwnershipCode = ref(initialOwnershipCode.value)
    const ownershipTouched = ref(false)
    watch(initialOwnershipCode, (code) => {
      selectedOwnershipCode.value = code
    }, { immediate: true })

    const fieldError = (field) => field.tochted
      ? Object.values(field.errors).find(Boolean) || ''
      : ''

    const buildPayload = async () => {
      ownershipTouched.value = true
      if (!await touchForm(form)) return null
      const flat = { ...useFormat(form), ownershipCode: selectedOwnershipCode.value, is_trailer: true }
      const validationError = validateTrailerCreateForm(flat)
      if (validationError) return null
      const sendFormData = buildCarCreatePayload(flat, ownershipOptions)
      sendFormData.is_trailer = true
      return sendFormData
    }

    const sendForm = async () => {
      const sendFormData = await buildPayload()
      if (!sendFormData) return
      if (isEdit.value) {
        if (props.initialData?.id != null) sendFormData.id = props.initialData.id
        emit('update', sendFormData)
        return
      }
      emit('sendForm', { model: 'cars', form: sendFormData })
    }

    const closeForm = () => {
      emit('closeForm')
    }

    const getFormObject = buildPayload

    return {
      sendForm,
      closeForm,
      form,
      fieldError,
      getFormObject,
      mode: props.mode,
      errors: props.errors,
      ownershipOptions,
      ownershipCode: selectedOwnershipCode,
      ownershipTouched,
    }
  },
}
</script>


<style scoped>
.form-actions {
  display: flex;
  gap: 20px;
  margin-top: 12px;
}

.cancel-btn {
  margin-left: 0;
}
</style>
